import React from "react";
import { withRouter } from "react-router";
import { graphql, compose } from "react-apollo";
import I18n from "../../I18n/I18n";
import {
  Button,
  DropDown,
  TextField,
  PageHeader,
  BagActionIcon,
  DetailsActionIcon,
  ContractActionIcon,
  ListActionIcon,
  SmileActionIcon,
  MapActionIcon,
  PositionActionIcon,
  Spinner
} from "dab-component-lib";
import {
  countriesQuery,
  businessAreasQuery,
  updateUserAfterRegistration,
  countriesTaxonomyQuery,
  currentUserQuery,
  registrationTexts,
  getText
} from "../../queries";
import {
  GridContainerStyle,
  LoadingStyle,
  ErrorStyle,
  PageHeaderWrapperStyle
} from "../../utils/style-utils";
import {
  RegRowStyle,
  RegColStyle,
  GreenWrapperStyle,
  FieldWrapperStyle,
  TitleStyle,
  DescriptionStyle
} from "./style";
import axios from "axios";
import { GET_NAME } from "../../utils/constants";
import { toggleUserType } from "../../actions/index";
import { connect } from "react-redux";

class CompleteRegistration extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      country: "",
      companyName: "",
      addressLine1: "",
      locality: "",
      vat: "",
      businessArea: "",
      givenName: "",
      familyName: "",
      error: false,
      errorMessage: "",
      provinces: [],
      loading: false
    };
  }

  changeUserType = () => {
    this.props.dispatch(toggleUserType(true));
  };

  updateUser = async () => {
    const {
      updateUserAfterRegistration,
      currentUserQuery: { loading, error, currentUserContext }
    } = this.props;
    this.setState({ loading: true });
    if (!loading && !error) {
      let user_data = await axios.get(`${GET_NAME}`, {
        withCredentials: true
      });
      let givenName = user_data.name ? user_data.name: 'no-name';
      let familyName = user_data.surname ? user_data.name : 'no-surname';
      let id = currentUserContext.uid;
      const {
        country,
        companyName,
        vat,
        businessArea,
        addressLine1,
        locality
      } = this.state;
      let data = await updateUserAfterRegistration({
        variables: {
          id,
          fieldVatNumber: vat,
          fieldCompanyName: companyName,
          fieldMainBusinessArea: businessArea.toString(),
          countryCode: country.toString(),
          addressLine1,
          locality,
          givenName,
          familyName
        }
      });
      this.setState({ loading: false });
      const { errors, violations } = data.data.updateUser;
      if (errors.length > 0 || violations.length > 0) {
        this.setState({
          loading: false,
          error: true,
          errorMessage: I18n.t("errors.fieldsRegisterError")
        });
      } else {
        this.changeUserType();
      }
    }
  };

  renderIcon = name => {
    switch (name) {
      case "BagActionIcon":
        return <BagActionIcon size={70} />;
      case "DetailsActionIcon":
        return <DetailsActionIcon size={70} />;
      case "ContractActionIcon":
        return <ContractActionIcon size={70} />;
      case "ListActionIcon":
        return <ListActionIcon size={70} />;
      case "SmileActionIcon":
        return <SmileActionIcon size={70} />;
      case "MapActionIcon":
        return <MapActionIcon size={70} />;
      case "PositionActionIcon":
        return <PositionActionIcon size={70} />;
      default:
        return <div />;
    }
  };

  render() {
    const {
      countriesTaxonomyQuery,
      businessAreasQuery,
      registrationTexts,
      getText
    } = this.props;
    const {
      companyName,
      vat,
      addressLine1,
      locality,
      error,
      loading
    } = this.state;
    let countries = [];
    let businessAreas = [];

    if (!countriesTaxonomyQuery.loading && !countriesTaxonomyQuery.error) {
      countriesTaxonomyQuery.taxonomygenericviewGraphql1View.results.forEach(
        country => {
          countries.push({
            label: country.name,
            value: country.fieldCountryCode
          });
        }
      );
    }

    if (!businessAreasQuery.loading && !businessAreasQuery.error) {
      businessAreasQuery.businessAreasGraphql1View.results.forEach(area => {
        businessAreas.push({
          label: area.name,
          value: area.tid
        });
      });
    }

    if (loading) {
      return (
        <LoadingStyle>
          <Spinner size={150} />
        </LoadingStyle>
      );
    }

    return (
      <GridContainerStyle>
        {(countriesQuery.loading ||
          businessAreasQuery.loading ||
          registrationTexts.loading ||
          getText.loading) && (
          <LoadingStyle>
            <Spinner size={150} />
          </LoadingStyle>
        )}
        {(countriesQuery.error ||
          businessAreasQuery.error ||
          registrationTexts.error ||
          getText.error) && (
          <ErrorStyle>
            <h3>{I18n.t("errors.formError")}</h3>
          </ErrorStyle>
        )}
        {!countriesQuery.loading &&
          !businessAreasQuery.loading &&
          !getText.loading &&
          !countriesQuery.error &&
          !businessAreasQuery.error &&
          !getText.error && (
            <div>
              <PageHeaderWrapperStyle>
                <PageHeader
                  title={
                    getText.translationMetadataGraphql1View.results.length >
                      0 &&
                    getText.translationMetadataGraphql1View.results[0]
                      .fieldMainText
                  }
                  description={
                    getText.translationMetadataGraphql1View.results.length >
                      0 &&
                    getText.translationMetadataGraphql1View.results[0]
                      .fieldSubText
                  }
                />
              </PageHeaderWrapperStyle>
              <RegRowStyle>
                <RegColStyle half>
                  <GreenWrapperStyle>
                    <FieldWrapperStyle>
                      <label htmlFor="vat-number">
                        {I18n.t("formFields.vatField")}
                        <span> *</span>
                      </label>
                      <TextField
                        disabled={false}
                        expanded
                        id="vat-number"
                        name={I18n.t("formFields.vatField")}
                        onBlur={function() {}}
                        onChange={event =>
                          this.setState({ vat: event.target.value })
                        }
                        onFocus={function() {}}
                        placeholder={I18n.t("formFields.vatField")}
                        readOnly={false}
                        required
                        type="text"
                        value={vat}
                      />
                    </FieldWrapperStyle>
                    <FieldWrapperStyle>
                      <label htmlFor="select-business">
                        {I18n.t("formFields.mainBusinessField")}
                        <span> *</span>
                      </label>
                      <DropDown
                        disabled={false}
                        expanded
                        id="select-business"
                        onChange={({ value }) =>
                          this.setState({ businessArea: value })
                        }
                        options={businessAreas}
                        placeholder={I18n.t("formFields.mainBusinessField")}
                        selectedIndex={null}
                        size="M"
                        skin="secondary"
                      />
                    </FieldWrapperStyle>
                    <FieldWrapperStyle>
                      <label htmlFor="company-name">
                        {I18n.t("formFields.companyNameField")}
                        <span> *</span>
                      </label>
                      <TextField
                        disabled={false}
                        expanded
                        id="company-name"
                        name={I18n.t("formFields.companyNameField")}
                        onBlur={function() {}}
                        onChange={event =>
                          this.setState({ companyName: event.target.value })
                        }
                        onFocus={function() {}}
                        placeholder={I18n.t("formFields.companyNameField")}
                        readOnly={false}
                        required
                        type="text"
                        value={companyName}
                      />
                    </FieldWrapperStyle>
                    <FieldWrapperStyle>
                      <label htmlFor="address">
                        {I18n.t("formFields.addressField")}
                        <span> *</span>
                      </label>
                      <TextField
                        disabled={false}
                        expanded
                        id="address"
                        name={I18n.t("formFields.addressField")}
                        onBlur={function() {}}
                        onChange={event =>
                          this.setState({ addressLine1: event.target.value })
                        }
                        onFocus={function() {}}
                        placeholder={I18n.t("formFields.addressField")}
                        readOnly={false}
                        required
                        type="text"
                        value={addressLine1}
                      />
                    </FieldWrapperStyle>
                    <FieldWrapperStyle>
                      <label htmlFor="locality">
                        {I18n.t("formFields.cityField")}
                        <span> *</span>
                      </label>
                      <TextField
                        disabled={false}
                        expanded
                        id="locality"
                        name={I18n.t("formFields.cityField")}
                        onBlur={function() {}}
                        onChange={event =>
                          this.setState({ locality: event.target.value })
                        }
                        onFocus={function() {}}
                        placeholder={I18n.t("formFields.cityField")}
                        readOnly={false}
                        required
                        type="text"
                        value={locality}
                      />
                    </FieldWrapperStyle>
                    <FieldWrapperStyle>
                      <label htmlFor="select-country">
                        {I18n.t("formFields.countryField")}
                        <span> *</span>
                      </label>
                      <DropDown
                        disabled={false}
                        expanded
                        id="select-country"
                        onChange={({ value }) =>
                          this.setState({ country: value })
                        }
                        options={countries}
                        placeholder={I18n.t("formFields.countryField")}
                        selectedIndex={null}
                        size="M"
                        skin="secondary"
                      />
                    </FieldWrapperStyle>
                    <Button
                      autoWidth={false}
                      disabled={false}
                      expanded={false}
                      icon={null}
                      id="complete-registration"
                      label={I18n.t("buttons.completeRegistration")}
                      onClick={() => this.updateUser()}
                      onMouseEnter={function() {}}
                      onMouseLeave={function() {}}
                      outline={false}
                      size="M"
                    />
                    {error && (
                      <div>
                        <h3>{I18n.t("errors.fieldsRegisterError")}</h3>
                      </div>
                    )}
                  </GreenWrapperStyle>
                </RegColStyle>
                <RegColStyle>
                  <TitleStyle>{I18n.t("content.whyRegister")}</TitleStyle>
                  {registrationTexts.nodeQuery &&
                    registrationTexts.nodeQuery.entities.length > 0 &&
                    registrationTexts.nodeQuery.entities[0].fieldSidebarLines.map(
                      text => {
                        return (
                          <DescriptionStyle key={text.entity.fieldLineText}>
                            {text.entity.fieldIconName.entity &&
                              this.renderIcon(
                                text.entity.fieldIconName.entity.name
                              )}
                            <p>{text.entity.fieldLineText}</p>
                          </DescriptionStyle>
                        );
                      }
                    )}
                </RegColStyle>
              </RegRowStyle>
            </div>
          )}
      </GridContainerStyle>
    );
  }
}

const mapStateToProps = ({ userType }) => {
  return { userType };
};

export default connect(mapStateToProps)(
  compose(
    graphql(countriesTaxonomyQuery, {
      name: "countriesTaxonomyQuery",
      options: props => ({
        variables: {
          vid: "availablecountriesforaddress"
        }
      })
    }),
    graphql(businessAreasQuery, {
      name: "businessAreasQuery",
      options: props => ({
        variables: {
          lang: localStorage.getItem("language")
            ? localStorage.getItem("language")
            : "it"
        }
      })
    }),
    graphql(updateUserAfterRegistration, {
      name: "updateUserAfterRegistration",
      options: props => ({
        refetchQueries: [{ query: currentUserQuery }]
      })
    }),
    graphql(currentUserQuery, {
      name: "currentUserQuery"
    }),
    graphql(registrationTexts, {
      name: "registrationTexts",
      options: props => ({
        variables: {
          lang: localStorage.getItem("language")
            ? localStorage.getItem("language")
            : "it"
        }
      })
    }),
    graphql(getText, {
      name: "getText",
      options: props => ({
        variables: {
          machineName: "complete_registration",
          lang: localStorage.getItem("language")
            ? localStorage.getItem("language")
            : "it"
        }
      })
    })
  )(withRouter(CompleteRegistration))
);



// WEBPACK FOOTER //
// ./src/components/completeRegistration/index.js